module.exports = __webpack_public_path__ + "media/images/tailwind/open-icon-9e7eed0d3f2cf5840f743bd2573e6e7a.png";